import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import type { Dispatch } from "redux";
import ImportPageFd from "../../components/ImportPageFd";
import { closeImportPageDialog, startImportPage } from "../../actions/pageActions";
import { getIsPageImporting } from "../../selectors/loading";
import { getIsPageImportingOpen } from "../../selectors/pageActions";
import type { State } from "../../pages/AppStoreWrapper";
import type { StateToProps, DispatchToProps, Props } from "./types/ImportPageDialog.type";

const mapStateToProps: (state: State) => StateToProps = (state) => ({
  isOpen: getIsPageImportingOpen(state),
  isPageImporting: getIsPageImporting(state),
});

const mapDispatchToProps: (arg0: Dispatch<any>) => DispatchToProps = dispatch => ({
  ...bindActionCreators({
    startImport: startImportPage,
    closeDialog: closeImportPageDialog,
  }, dispatch),
});

function ImportPageDialog({
  isOpen,
  isPageImporting,
  startImport,
  closeDialog,
}: Props) {
  const handleApply = (file: Record<string, unknown>, type: string, activate: boolean) => {
    startImport(file as unknown as File, type, activate);
  };

  return (
    <ImportPageFd
      open={isOpen}
      importing={isPageImporting}
      onApply={handleApply}
      onClose={closeDialog}
    />
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ImportPageDialog);
